<template>
      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header card-header-info">
                        <h4 class="card-title ">Form Tambah Poin</h4>
                      </div>
                      <div class="card-body">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label class="bmd-label-floating">Jumlah Poin</label>
                                <input type="text" class="form-control" placeholder="Jumlah Poin..." v-model="jumlah">
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group">
                                <label class="bmd-label-floating">Sales </label>
			                          <select class="form-control" id="exampleFormControlSelect1"  v-model="sales">
                                  <option value="" selected>No Marketing</option>
                                  <option  v-for="(ser, index) in listMarketing" :value="ser.u_id">{{ser.u_nama}}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <button type="submit" class="btn btn-success pull-right btn-round" v-show="simpanBtn" @click="simpan">Simpan</button>
                          <p class="form-text text-danger" v-show="infoTambah">Tidak boleh ada yang kosong</p>
                          <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor from 'vue-ckeditor5'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'

const options = {
  editors: {
    classic: ClassicEditor,
  },
  name: 'ckeditor'
}

Vue.use(VueCkeditor.plugin, options);

export default {
  components: { 
  }, 
  data() {
    return {
      title: "Tambah Admin",
      simpanBtn: true,
      jumlah: '',
      sales: '',
			listMarketing: [],
    }
  },
  watch: {
    cpass: 'ketik'
  },
  methods: {
    simpan() {
      if (this.jumlah != '' && this.sales != '') {
        this.simpanBtn = false;
        var data = new FormData();
        data.append('ke', 'sales-tambah-poin');
        data.append('jumlah', this.jumlah);
        data.append('sales', this.sales);
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        
        //axios.defaults.headers.common['Kentangization'] = 'TangTung '+localStorage.getItem('myToken');
        axios
          .post(url+'API.php', data)
          .then(response => (
              //console.log(response.data.lastId),
              this.simpanResult(response.data.lastId)

            ))
            .catch(error => {
              console.log(error)
              
            })
            .finally()
      
      } else {
        alert('Terdapat data yang kosong');
      }
      
    },
    simpanResult(id) {
          location.href = "#/sales"
    }
  },
	mounted () {
		var data = new FormData();
		data.append('ke', 'servis-last');
		data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));

		axios
			.post(url+'API.php',data)
			.then(response => (
		  	/*this.info = response*/ 
		  		console.log(JSON.stringify(response.data)),
				  this.noServisData = 'SRV'+parseInt(+response.data.servis[0].data+1),
				  this.listMarketing = response.data.marketing
		  	))
	    	.catch(error => {
	        	console.log(error.response);
	        	if (error.response.status == 401) {
			      // Request made and server responded
			      alert('Silahkan Login terlebih dahulu');
			      location.href=homePage
			    } else { 
			      alert('Silahkan Login terlebih dahulu');
			      location.href=homePage
			    }
	    	})
	    	.finally(() => this.loadingText = false)
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.pilih-file {
  position: static !important;
  opacity: 1 !important;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/NOPAKAI/BACKUP/sales/tambah-poin.vue